import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import Select from "react-select";
import { createEvent, deleteEvent, updateEvent } from "../../utils/event";
import { db } from "../../index";
import { useProviderOptions } from "../../store/actions/providerActions";
import { FooterActionsContainer } from "../layout/Footer";
import { OutlineButton } from "../layout/OutlineButton";

export default function EventsAddOrUpdateContent() {
  const history = useHistory();
  const params = useParams();
  const eventId = params?.event_id;

  const { userInfos } = useContext(UserContext);
  const providerOptions = useProviderOptions();

  const [isFetching, setIsFetching] = useState(false);
  const [formError, setFormError] = useState([]);
  const [event, setEvent] = useState({
    name: "",
    provider: {
      id: "",
      name: "",
      phone: "",
      tel: "",
      company: {
        id: "",
        name: "",
      },
    },
  });

  useEffect(() => {
    if (eventId && userInfos?.uid) {
      db.ref(`users/${userInfos.uid}/events/${eventId}`)
        .once("value", (snapshot) => {
          const res = snapshot.val();
          setEvent({ ...res, id: snapshot.key });
        })
        .then();
    }
  }, [eventId, userInfos?.uid]);

  function handleChange(e) {
    const { name, value } = e.target;
    setEvent((old) => ({
      ...old,
      [name]: value,
    }));
  }

  async function handleDeleteEvent() {
    await deleteEvent(userInfos, eventId);
    history.push("/events");
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    if (handleValidation()) {
      setIsFetching(true);

      if (eventId) {
        await updateEvent(userInfos, event);
        window.alert("L'évènement a été mis à jour avec succès");
      } else {
        await createEvent(userInfos, event);
        history.push("/events");
      }

      setIsFetching(false);
    }
  }

  function handleValidation() {
    let valid = true;
    let message = [];

    if (event.name === "") {
      valid = false;
      message.push("Veuillez renseigner le nom de l'événement");
    }

    if (event.company?.id === "") {
      valid = false;
      message.push("Veuillez renseigner la compagnie");
    }

    setFormError(message);

    return valid;
  }

  const FormAlert = useMemo(() => {
    const alert =
      formError.length > 0 ? (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ flexDirection: "column" }}
        >
          {formError.map((error, index) => {
            return (
              <div
                className="alert-text"
                key={index}
                style={{ alignSelf: "flex-start" }}
              >
                {error}
              </div>
            );
          })}
        </div>
      ) : (
        ""
      );

    return (
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        {alert}
      </div>
    );
  }, [formError]);

  function handleProviderChange(provider) {
    setEvent((old) => ({
      ...old,
      provider: {
        ...provider.data,
        key: provider.data.id,
      },
    }));
  }

  const buttonText =
    isFetching === true ? (
      <button type="submit" className="btn btn-primary px-5" disabled>
        {eventId ? "Mise à jour..." : "Création..."}
      </button>
    ) : (
      <button type="submit" className="btn btn-primary px-5">
        {eventId ? "Mettre à jour l'évènement" : "Créer l'évènement"}
      </button>
    );

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {eventId ? event?.name : "Ajouter un évènement"}{" "}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/events/" className="kt-subheader__breadcrumbs-link">
                Evènements
              </Link>
              {eventId ? (
                <>
                  <span className="kt-subheader__breadcrumbs-separator"></span>
                  <Link
                    to={"/events/" + eventId}
                    className="kt-subheader__breadcrumbs-link"
                  >
                    {event.name}
                  </Link>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {FormAlert}

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">Données de l'évènement</h3>
            </div>
          </div>
          <form onSubmit={handleFormSubmit} className="kt-form">
            <div className="kt-portlet__body">
              <div className="kt-section kt-section--first">
                <div className="kt-section__body">
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Nom de l'évenement:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={event.name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Client:</label>
                    <div className="col-lg-6">
                      <Select
                        options={providerOptions}
                        onChange={handleProviderChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label"></label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="provider"
                        value={event.provider?.name}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <FooterActionsContainer>
              <div>
                <OutlineButton type="button" onClick={history.goBack}>
                  <i className="fas fa-arrow-left" />
                  Retour
                </OutlineButton>
              </div>
              <div>{buttonText}</div>
              <div>
                {eventId && (
                  <OutlineButton
                    type="button"
                    data-toggle="modal"
                    data-target="#delete_modal"
                  >
                    <i className="fas fa-trash-alt" />
                    Supprimer
                  </OutlineButton>
                )}
              </div>
            </FooterActionsContainer>
          </form>
        </div>
      </div>
      <div
        className="modal fade"
        id="delete_modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Supprimer l'évènement
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Êtes-vous sûr de vouloir supprimer cet évènement ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleDeleteEvent}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
